import React, { useContext } from 'react'

export const AuthContext = React.createContext(null)
export const useAuthContext = () => useContext(AuthContext)
